<template>
  <div>
    <canvas id="costoItem" ref="costoItem" width="400" height="400"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getStyle } from "@coreui/coreui-pro/dist/js/coreui-utilities";

// const CHART_COLORS = [
//   getStyle("--primary"),
//   getStyle("--info"),
//   getStyle("--success"),
//   getStyle("--warning"),
//   getStyle("--secondary"),
//   getStyle("--dark"),
//   getStyle("--danger")
// ];
// const CHART_COLORS = [
//   // "#a4133c",
//   "#c9184a",
//   "#ff4d6d",
//   "#ff758f",
//   "#ff8fa3",
//   "#ffb3c1",
//   "#ffccd5"
// ];

const CHART_COLORS = [
  "#ff7b00",
  // "#ff8800",
  "#ff9500",
  // "#ffa200",
  "#ffaa00",
  // "#ffb700",
  "#ffc300",
  // "#ffd000",
  "#ffdd00",
  "#ffea00"
];

export default {
  name: "CostoItem",
  props: {
    chartData: {
      type: Object,
      default: () => {}
    },
    dataReady: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chartSetup: {}
    };
  },
  methods: {
    prepareData() {
      const labels = this.chartData.labels;
      const dataset = this.chartData.dataset;
      const data = {
        type: "doughnut",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Pallets",
              data: dataset,
              backgroundColor: CHART_COLORS,
              borderWidth: 1,
              datalabels: {
                anchor: "center",
                align: "start",
                display: "auto",
                formatter: function (value, context) {
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  return new Intl.NumberFormat("es-CL").format(((100 * value) / total).toFixed(0)) + " %";
                }
              }
            }
          ]
        },
        plugins: [ChartDataLabels],
        options: {
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: "right"
            },
            datalabels: {
              color: "#043e73"
            },
            title: {
              display: false,
              align: "start",
              text: "Antiguedad de Stock"
            }
          }
        }
      };
      return data;
    },
    async buildChart() {
      console.log("building Chart...");
      let ctx = this.$refs.costoItem.getContext("2d");
      const setup = await this.prepareData();
      let chartBuilded = false;
      const myChart = new Chart(ctx, setup);
    }
  },
  watch: {
    dataReady(newVal, oldVal) {
      console.log("dataReady", newVal);
      if (newVal) {
        setTimeout(() => {
          this.buildChart();
        }, 1000);
      }
    }
  },
  // mounted() {
  //   this.buildChart();
  // },
  beforeMount() {
    // this.prepareData();
  }
};
</script>

<style></style>
